import { configureStore } from '@reduxjs/toolkit';
import loadingReducer from './slices/loadingSlice';
import loginReducer from './slices/loginSlice'
import toastReducer from './slices/toastSlice'
import sideBarReducer from './slices/sideBar'
import networkSlice from './slices/netWorkErr'

export const store = configureStore({
  reducer: {
    loading: loadingReducer,
    login : loginReducer,
    toast : toastReducer,
    sideBar:sideBarReducer,
    network:networkSlice,
  },
});
